<template>
  <div id="home" class="page home">
    <page-header :data="data.header"></page-header>
    <section class="section section--hero">
      <div class="background-layer">
        <img :src="data.images.hero" class="img" alt="hero-img">
      </div>

      <div class="text-layer">
        <h1 class="text-layer__headline">{{data.sections.hero.headline}}</h1>
        <p class="text-layer__subheadline">{{data.sections.hero.subheadline}}</p>
      </div>
    </section>

    <section class="section section--about">
      <div class="container">
        <div class="row">
          <div class="col-md-6 mb-4">
            <p class="text mb-4">{{data.sections.about.text1}}</p>
            <p class="text">{{data.sections.about.text2}}</p>
          </div>
          <div class="col-md-6 my-4">
            <h3 class="section__subheadline mb-4">{{data.sections.about.goals.headline}}</h3>
            <div class="row">
              <div class="col-md-4 goal-item"
                v-for="(item, index) in data.sections.about.goals.items" :key="index"
                >
                <img :src="item.icon" alt=">" class="img goal-icon" />
                <p class="text my-5">{{item.text}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section--services" id="services">
        <div class="headline-container">
          <h2 class="section__headline">{{data.sections.services.headline}}</h2>
        </div>

      <div class="container content-container">
        <div class="row">
          <div v-for="(item,index) in data.sections.services.items"
            :key="index"
            class="col-6 col-md-4 col-lg-3 mb-3"
            >
            <div class="services-item">
              <p class="text">{{item}}</p>
            </div>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-5">
          <p class="text text-center col-lg-8">{{data.sections.services.text}}</p>
        </div>
      </div>
    </section>

    <section class="section section--diagram">
      <div class="container">
        <img :src="data.images.diagram" alt="diagram" class="img">
      </div>
    </section>

    <section class="section section--products" id="products">
      <div class="headline-container">
        <h2 class="section__headline">{{data.sections.products.headline}}</h2>
      </div>
      <div class="container">
        <div class="row">
          <div v-for="(item, index) in data.sections.products.items" :key="index"
          class="col-md-6">
            <div class="product-item mb-4">
              <div class="icon-container">
                <img :src="item.icon" alt="icon" class="img product-icon">
              </div>
              <p class="text">{{item.text}}</p>
            </div>
          </div>
        </div>

        <p class="my-5 text text-center">
          <a href="#contact" class="link link--contact">{{data.sections.products.contactLink}}</a> {{data.sections.products.requestDemo}}
        </p>
      </div>
    </section>

    <section class="section section--rd d-none" id="rd">
      <div class="headline-container">
        <h2 class="section__headline">{{data.sections.rdprojects.headline}}</h2>
      </div>
      <div class="container content-container">
        <div class="row">
          <div v-for="(item, index) in data.sections.rdprojects.items" :key="index"
           class="col-6 col-md-4 col-lg-3 mb-3">
            <div class="projects-item mb-4">
              <img :src="item.logo" alt="Project Logo" class="img project-logo">
              <div class="project-description">
                <p class="text">{{item.description}}</p>
                <a v-if="!!item.link" :href="item.link" class="project-link" target="_blank">Go to project</a>
              </div>
            </div>
          </div>
        </div>
        <p class="text my-3 text-center">Projects are implemented in our sister companies Nuromedia GmbH and Nurogames GmbH</p>
      </div>
    </section>

    <section class="section section--contact" id="contact">
      <div class="background-layer">
        <img :src="data.images.background" alt="" class="img">
      </div>
      <div class="container form-container d-flex flex-column justify-space-around align-center">
        <div class="headline-container">
          <h2 class="section__headline">{{data.sections.contact.headline}}</h2>
        </div>
        <p class="text text-center my-5">{{data.sections.contact.text}}</p>
     
       <contact-form :data="data.sections.contact"></contact-form>

       <div class="social row d-flex justify-content-end">
         <div v-for="(item, index) in data.sections.contact.social" :key="index" class="social__item col-auto">
           <a :href="item.link" v-html="item.icon" class="social__link" target="_blank"></a>
         </div>
       </div>

      </div>
    </section>

    <page-footer :data="data.footer"></page-footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';
import ContactForm from '../components/ContactForm.vue';

export default {
  name: 'Home',
  props: ['data'],
  components: {
    'page-header': Header,
    'page-footer': Footer,
    'contact-form': ContactForm
  },
  data() {
    return this.data;
  }
}
</script>

<style lang="scss">
.page.home {
  position: relative;
  background-color: $white;
  
  .img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .section {
    height: auto;
    width: 100%;
    max-width: 100vw;
    position: relative;

    scroll-padding-top: 5rem;

    &--services,
    &--rd {
      margin-top: 5rem;
    }

    .background-layer {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      max-height: 100%;
      overflow: hidden;
      background-color: $dark-blue;
      z-index: 0;
    }

    .headline-container {
      height: 15rem;
      background-color: $white;
    }

    &__headline {
      position: relative;
      font-size: 3.125rem;
      color: $black;
      font-weight: bold;
      text-align: center;
      height: 7.5rem;
      &::after {
        display: inline-block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        width: 9.375rem;
        height: .625rem;
        background-color: $secondary;
        content: '';
      }
    }

    &__subheadline {
      font-size: 1.875rem;
      color: $black;
      font-weight: bold;
      text-align: center;
    }
  }

  .section.section--hero {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .text-layer {
      color: $white;
      text-align: center;
      width: auto;
      min-width: 62%;
      max-width: 66rem;
      z-index: 1;

      &__headline {
        font-size: 5rem;
        font-weight: bold;
        line-height: 1;
      }

      &__subheadline {
        font-size: 1.625rem;
        line-height: 1.5;
      }
    }

    @media (max-width: 991.98px) {
      .text-layer {
        max-width: 90%;

        &__headline {
          font-size: 3rem;
          line-height: 1.25;
        }

        &__subheadline {
          font-size: 1.5rem;
        }
      }

      .background-layer {
        height: 100%;

        .img {
          height: 100%;
          width: auto;
        }
      }
    }
  }

  .section.section--about {
    height: auto;
    background-color: $white;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2.5rem 0 0 0;

    @media (min-width: 992px) {
      padding: 7.5rem 0 0 0;
    }
    .goal-item {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
      padding: 1rem;

      .goal-icon {
        max-width: 7.5rem;
      }

      .text {
        text-align: center;
        max-width: 7.5rem;
      }
    }

    .text {
      font-size: 1.25rem;
      color: $gray;
      text-align: left;
    }

  }

  .section.section--services {
    height: auto;
    min-height: 100vh;
    background-color: $light-gray;

    .text {
      font-size: 1.25rem;
    }

    .content-container {
      margin-top: -4.625rem;
    }

    .services-item {
      background-color: $primary;
      border-radius: 0.625rem;
      height: 9.375rem;
      display: flex;
      align-items: center;
      justify-content: center;

      .text {
        width: auto;
        max-width: 75%;
        color: $white;
        text-align: center;
      }

      &:hover {
        cursor: pointer;
        background-color: $white;

        .text {
          color: $primary;
        }
      }

      transition: all .3s ease-in;
    }

  }

  .section.section--diagram {
    height: auto;
    padding-top: 5rem;
    background-color: $light-gray;
  }

  .section.section--products {
    height: auto;
    min-height: 100vh;
    padding-top: 5rem;
    background-color: $white;

    .text {
      font-size: 1.25rem;
    }

    .product-item {
      position: relative;
      border-radius: 0.625rem;
      height: 17.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $light-gray;

      margin-left: 6.25rem;

      .icon-container {
        height: 12.5rem;
        width: 12.5rem;
        margin-left: -6.25rem;
        border-radius: 50%;
        border: .625rem solid $light-gray;
        background-color: white;
        padding: 2rem;

        .img.product-icon {
          height: 100%;
          width: auto;
          object-fit: contain;
        }
      }


      .text {
        width: auto;
        max-width: 20rem;
        color: $gray;
        text-align: left;
      }
    }

    .link.link--contact {
      color: $secondary;

      &:hover {
        color: $primary;
      }
    }
  }

  .section.section--rd {
    display: none;
    height: auto;
    min-height: 100vh;
    background-color: $light-gray;
    padding-bottom: 4rem;

    .content-container {
      margin-top: -6.25rem;
    }

    .projects-item {
      position: relative;
      background-color: $white;
      border-radius: 0.625rem;
      height: 12.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1.75rem;
      overflow: hidden;

      .img.project-logo {
        width: 100%;
        height: auto;
        max-height: 100%;
        object-fit: contain;
      }

      .project-description {
        visibility: hidden;
        transform: translate(0, -100%);
        transition: transform .3s ease-in-out;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba($color: $primary, $alpha: 0.9);
        z-index: 3;
        border: 0;
        border-radius: .625rem;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: space-evenly;

        .text {
          font-size: 1rem;
          color: $white;
          max-width: 90%;
        }

        .project-link {
          font-size: 1rem;
          color: $white;
          text-decoration: underline;

          &:hover {
            cursor: pointer;
            color: $secondary;
          }
        }
      }

      &:hover .project-description {
        visibility: visible;
        transform: translate(0, 0);
      }
    }
  }

  .section.section--contact {
    padding: 5rem 1rem;
    margin-top: 7.5rem;
    min-height: 100vh;

    .form-container {
      position: relative;
      background-color: $light-gray;
      color: $gray;
      border-radius: 0.625rem;
      z-index: 10;
      padding: 5rem 1rem;
      max-width: 50rem;

      @media(min-width: 992px) {
        padding: 5rem 5rem;
      }
      
      .headline-container {
        background-color: transparent;
        height: auto;
      }
    }

    .social {
      &__item {
        height: 2rem;
      }

      &__link {
        color: $gray;
        svg {
          height: 100%;
          width: auto;
          object-fit: contain;
          fill: currentColor;
        }
      }
    }

    @media (max-width: 992px) {
      .background-layer {
        .img {
          height: 100vh;
        }
      }
    }
  }
}
</style>